import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

type Option = { label: string; value: any };

@Component({
  selector: 'sigecom-radio-toggle',
  template: `
    <label class="text-sm font-semibold text-sigecom-dark-gray ml-2">
      {{ label }}<span *ngIf="required" class="text-sigecom-danger">*</span>
    </label>

    <div class="flex items-center gap-4 mt-2">
      <label
        *ngFor="let option of options"
        class="flex items-center gap-2 cursor-pointer"
      >
        <input
          type="radio"
          [name]="label"
          class="appearance-none w-4 h-4 border-2 rounded-full border-sigecom-dark-gray checked:border-4 checked:border-cbde-dark-blue"
          [checked]="selected === option[valueKey]"
          (change)="select(option[valueKey])"
        />
        <span class="text-sigecom-dark-gray">
          {{ option[labelKey] }}
        </span>
      </label>
    </div>
  `,
})
export class RadioToggleComponent {
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() options?: Option[] = [{ label: 'Sim', value: true }, { label: 'Não', value: false }];

  @Input() labelKey: keyof Option = 'label';
  @Input() valueKey: keyof Option = 'value';

  @Input() selected: any;
  @Output() selectedChange = new EventEmitter<any>();

  select(value: any) {
    this.selected = value;
    this.selectedChange.emit(value);
  }
}
